import { BOOKINGAPI } from '../../helpers/api'

export function getPasswordConfig(tenantId) {
  return BOOKINGAPI.get(`/tenant/secretrule/${tenantId}`)
}

export function updatePasswordConfig(params) {
  return BOOKINGAPI.post('/tenant/secretrule', params)
}
